import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { useProfileData } from "../../../hooks/useProfileData";
import { getEntityFollowers } from "../../services/entities";

type UseNewFollowersStatisticsResult = {
  statistics: {
    count: number;
    data: { items: { day: string; count: number }[] };
  };
  isStatisticsLoading: boolean;
  isStatisticsHasError: boolean;
};

export const useNewFollowersStatistics = (duration: string): UseNewFollowersStatisticsResult => {
  const { i18n } = useTranslation();
  const { data: userData, isLoading: isUserDataLoading, isError: isUserDataHasError } = useProfileData();
  const entityId = userData?.entityId;

  const {
    data: statistics,
    isLoading: isStatisticsLoading,
    isError: isStatisticsHasError,
  } = useQuery<any>({
    queryKey: ["Dashboard", "NewFollowers", i18n.language, entityId, duration],
    queryFn: async () => await getEntityFollowers(entityId, duration),
    enabled: !!entityId,
  });

  return {
    statistics: statistics,
    isStatisticsLoading: isUserDataLoading || isStatisticsLoading,
    isStatisticsHasError: isStatisticsHasError || isUserDataHasError,
  };
};
